var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.items),function(item,index){return [(item.type === 'divider')?_c('span',{key:index,staticClass:"divider"}):_c('rich-text-editor-menu-bar-item',_vm._b({key:index},'rich-text-editor-menu-bar-item',item,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }